import React from 'react'
import { Row, Col, Space, Typography, Form, Input, Button, Select, Table, AutoComplete, message } from 'antd'
import { reqRetriveTraits, reqSearchTrait } from '../../api'

const { Paragraph } = Typography
const { Option } = Select

class SearchTrait extends React.Component {
    state = {
        // form 表单状态
        dataset: '',
        traits_options: [],
        trait1: '',
        val_start1: '',
        val_end1: '',
        trait2: '',
        val_start2: '',
        val_end2: '',
        trait3: '',
        val_start3: '',
        val_end3: '',
        trait4: '',
        val_start4: '',
        val_end4: '',
        trait5: '',
        val_start5: '',
        val_end5: '',
        condition: '',
        disabled: false,    // 控制submit按钮的可用状态
        // 结果table状态 
        title: '',
        loading: false,
        has_data: false,
        searchResult: '',
        pagination: {
            current: '',
            pageSize: '',
            total: '',
            showSizeChanger: false,
            showQuickJumper: true
        }
    }
    
    formRef = React.createRef()

    onFinish = async (values) => {
        let { dataset, trait1, val_start1, val_end1, trait2, val_start2, val_end2, trait3, val_start3, val_end3, trait4, val_start4, val_end4, trait5, val_start5, val_end5, condition } = values
        
        this.setState({
            disabled: true,
            loading: true
        })

        let traits = '', query = '', query1 = '', query2 = '', query3 = '', query4 = '', query5 = ''
        if (trait1 && trait1 != undefined) {
            traits = trait1
            let qtrait1 = '$' + trait1
            if (val_start1) {
                query1 = qtrait1 + '>=' + val_start1
            }
            if (val_end1) {
                query1 += '&&' + qtrait1 + '<=' + val_end1
            }
        }

        if (trait2 && trait2 != undefined) {
            traits += ',' + trait2
            let qtrait2 = '$' + trait2
            if (val_start2) {
                query2 = qtrait2 + '>=' + val_start2
            }
            if (val_end2) {
                query2 += '&&' + qtrait2 + '<=' + val_end2
            }
        }

        if (trait3 && trait3 != undefined) {
            traits += ',' + trait3
            let qtrait3 = '$' + trait3
            if (val_start3) {
                query3 = qtrait3 + '>=' + val_start3
            }
            if (val_end3) {
                query3 += '&&' + qtrait3 + '<=' + val_end3
            }
        }

        if (trait4 && trait4 != undefined) {
            traits += ',' + trait4
            let qtrait4 = '$' + trait4
            if (val_start4) {
                query4 = qtrait4 + '>=' + val_start4
            }
            if (val_end4) {
                query4 += '&&' + qtrait4 + '<=' + val_end4
            }
        }

        if (trait5 && trait5 != undefined) {
            traits += ',' + trait5
            let qtrait5 = '$' + trait5
            if (val_start5) {
                query5 = qtrait5 + '>=' + val_start5
            }
            if (val_end5) {
                query5 += '&&' + qtrait5 + '<=' + val_end5
            }
        }
                
        let logic = ''
        if (condition == 'and') {
            logic = '&&'
        } else if (condition == 'or') {
            logic = '||'
        }

        if (query1) {
            query = query1
        }
        if (query2) {
            query += logic + query2
        }
        if (query3) {
            query += logic + query3
        }
        if (query4) {
            query += logic + query4
        }
        if (query5) {
            query += logic + query5
        }

        const searchResult = await reqSearchTrait(dataset, query, traits)
        let table_title = ''
        if (searchResult.code === 0) {
            table_title = () => {
                return <span><b>{searchResult.data.length}</b> records were returned.</span>
            }

            this.setState({
                dataset: dataset,
                trait1: trait1,
                val_start1: val_start1,
                val_end1: val_end1,
                trait2: trait2,
                val_start2: val_start2,
                val_end2: val_end2,
                trait3: trait3,
                val_start3: val_start3,
                val_end3: val_end3,
                trait4: trait4,
                val_start4: val_start4,
                val_end4: val_end4,
                trait5: trait5,
                val_start5: val_start5,
                val_end5: val_end5,
                condition: condition,
                disabled: false,
                title: table_title,
                loading: false,
                has_data: true,
                searchResult: searchResult.data,
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    //分页、排序、筛选变化时触发
    onTableChange = async (pagination, filters, sorter) => {
        let { dataset, trait1, val_start1, val_end1, trait2, val_start2, val_end2, trait3, val_start3, val_end3, trait4, val_start4, val_end4, trait5, val_start5, val_end5, condition } = this.state
        const { current } = pagination

        let traits = '', query = '', query1 = '', query2 = '', query3 = '', query4 = '', query5 = ''
        if (trait1 && trait1 != undefined) {
            traits = trait1
            let qtrait1 = '$' + trait1
            if (val_start1) {
                query1 = qtrait1 + '>=' + val_start1
            }
            if (val_end1) {
                query1 += '&&' + qtrait1 + '<=' + val_end1
            }
        }

        if (trait2 && trait2 != undefined) {
            traits += ',' + trait2
            let qtrait2 = '$' + trait2
            if (val_start2) {
                query2 = qtrait2 + '>=' + val_start2
            }
            if (val_end2) {
                query2 += '&&' + qtrait2 + '<=' + val_end2
            }
        }

        if (trait3 && trait3 != undefined) {
            traits += ',' + trait3
            let qtrait3 = '$' + trait3
            if (val_start3) {
                query3 = qtrait3 + '>=' + val_start3
            }
            if (val_end3) {
                query3 += '&&' + qtrait3 + '<=' + val_end3
            }
        }

        if (trait4 && trait4 != undefined) {
            traits += ',' + trait4
            let qtrait4 = '$' + trait4
            if (val_start4) {
                query4 = qtrait4 + '>=' + val_start4
            }
            if (val_end4) {
                query4 += '&&' + qtrait4 + '<=' + val_end4
            }
        }

        if (trait5 && trait5 != undefined) {
            traits += ',' + trait5
            let qtrait5 = '$' + trait5
            if (val_start5) {
                query5 = qtrait5 + '>=' + val_start5
            }
            if (val_end5) {
                query5 += '&&' + qtrait5 + '<=' + val_end5
            }
        }
                
        let logic = ''
        if (condition == 'and') {
            logic = '&&'
        } else if (condition == 'or') {
            logic = '||'
        }

        if (query1) {
            query = query1
        }
        if (query2) {
            query += logic + query2
        }
        if (query3) {
            query += logic + query3
        }
        if (query4) {
            query += logic + query4
        }
        if (query5) {
            query += logic + query5
        }

        const searchResult = await reqSearchTrait(dataset, query, traits)
        if (searchResult.code === 0) {
            this.setState({
                searchResult: searchResult.data,
                pagination: {
                    current: current,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    // 表单重置
    onReset = () => {
        this.formRef.current.resetFields()
        this.setState({
            ref_genome_options: [],
            variant_type_options: [],
            chr_options: []
        })
    }

    onDatasetChange = async (val) => {
        if (val !=  '') {
            const result = await reqRetriveTraits(val)
            let traits_options = []
            if (result.code === 0) {
                traits_options = result.data.map((item) => {
                    return <Option value={item} key={item}>{item}</Option>
                })
            }

            this.setState({
                traits_options: traits_options
            })
        }
    }

    render() {
        const { traits_options, trait1, val_start1, val_end1, trait2, val_start2, val_end2, trait3, val_start3, val_end3, trait4, val_start4, val_end4, trait5, val_start5, val_end5, searchResult, disabled, title, loading, has_data, pagination } = this.state
        
        const layout = {
            colon: false
        }
        const tailLayout = {
            wrapperCol: { span: 12 },
        }

        let columns = [
            {
                title: 'Germplasm',
                dataIndex: 'taxa',
            }
        ]
        if (trait1) {
            columns.push({
                title: trait1,
                dataIndex: trait1
            })
        }
        if (trait2) {
            columns.push({
                title: trait2,
                dataIndex: trait2
            })
        }
        if (trait3) {
            columns.push({
                title: trait3,
                dataIndex: trait3
            })
        }
        if (trait4) {
            columns.push({
                title: trait4,
                dataIndex: trait4
            })
        }
        if (trait5) {
            columns.push({
                title: trait5,
                dataIndex: trait5
            })
        }


        if (searchResult) {
            for (let v of searchResult){
                v['key'] = v['taxa']
            }
        }

        return (
            <React.Fragment>
                <Form {...layout} labelAlign="left" name="search-trait" ref={this.formRef} className="search-trait-form" onFinish={this.onFinish}>
                    <Paragraph>
                        Search for phenotype traits and metabolites by their values.
                    </Paragraph>
                    <Form.Item name="dataset" label="Dataset" wrapperCol={{span: 6}} rules={[{ required: true }]}>
                        <Select placeholder="Select dataset" showSearch showArrow allowClear onChange={this.onDatasetChange}>
                            <Option value="cell_mean_metabolism">cell mean metabolism</Option>
                            <Option value="science_metabolite">science metabolite</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="condition" label="Condition" wrapperCol={{span: 6}} rules={[{ required: true }]}>
                        <Select showArrow allowClear>
                            <Option value="and">and</Option>
                            <Option value="or">or</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="trait1" label="Trait1" rules={[{ required: true }]}>
                                            <Select placeholder="Select trait" showSearch showArrow allowClear>
                                                { traits_options }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_start1" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    required: true,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_end1" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    required: true,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="trait2" label="Trait2">
                                            <Select placeholder="Select trait" showSearch showArrow allowClear>
                                                { traits_options }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_start2" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_end2" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="trait3" label="Trait3">
                                            <Select placeholder="Select trait" showSearch showArrow allowClear>
                                                { traits_options }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_start3" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_end3" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="trait4" label="Trait4">
                                            <Select placeholder="Select trait" showSearch showArrow allowClear>
                                                { traits_options }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_start4" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_end4" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="trait5" label="Trait5">
                                            <Select placeholder="Select trait" showSearch showArrow allowClear>
                                                { traits_options }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_start5" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="val_end5" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Table bordered title={title} loading={loading} has_data={has_data} columns={columns} dataSource={searchResult} size="middle" sticky={true} pagination={pagination} onChange={this.onTableChange} className="search-result-table" />
            </React.Fragment>
        )
    }
}

export default SearchTrait
